import { resetConfirmCodeFormsAndClearErrors } from "../wcl-helpers";

document.addEventListener('DOMContentLoaded', () => {

   // Elements
   const modals = document.querySelector('.wcl-modal-layout');

   const openModalButtons = document.querySelectorAll('.wcl-open-modal');
   const modalCloseButtons = document.querySelectorAll('.wcl-modal-close');
   const targetButtons = document.querySelectorAll('[data-target]');
   const bodyWrapper = document.querySelector('body');

   /*
   * Open modal
   */
   openModalButtons.forEach(button => {
      button.addEventListener('click', () => {
         if (modals) {
            modals.classList.add('active');
            bodyWrapper.classList.add('overflow-hidden');
         }
      });
   });


   /*
   * Closing a modal window
   */
   modalCloseButtons.forEach(button => {
      button.addEventListener('click', () => {
         const modal = button.closest('.wcl-modal-layout');

         if (modal) {
            modal.classList.remove('active');
            bodyWrapper.classList.remove('overflow-hidden');
            resetConfirmCodeFormsAndClearErrors();
         }
      });
   });


   // Closing a modal window when clicked outside the wrapper
   const modalsLayout = document.querySelectorAll('.wcl-modal-layout-active-overlay');

   modalsLayout.forEach(modal => {
      const modalInnerWrapper = modal.querySelectorAll('.wcl-modal-inner');
      const elementsArray = Array.from(modalInnerWrapper);

      modal.addEventListener('click', (e) => {
         const wrapper = elementsArray.some(element => element.contains(e.target));

         if (!wrapper) {
            modal.classList.remove('active');
            bodyWrapper.classList.remove('overflow-hidden');
            resetConfirmCodeFormsAndClearErrors();
         }
      });
   });


   /*
   * Switching active windows with forms
   */

   // Function to remove 'active' class from all forms with 'wcl-modal-inner' class
   function hiddenAllForms() {
      const popupsModalLayout = document.getElementById('wcl-popup');
      const modalsInner = popupsModalLayout.querySelectorAll('.wcl-modal-inner');

      modalsInner.forEach(modal => {
         modal.classList.remove('active');
      });
   }

   // Event handler for buttons with data-target attribute
   targetButtons.forEach(button => {
      button.addEventListener('click', (e) => {
         e.preventDefault();
         hiddenAllForms();
         const targetFormId = button.getAttribute('data-target');
         const targetForm = document.getElementById(targetFormId);

         if (targetForm) {
            targetForm.classList.add('active');
            bodyWrapper.classList.add('overflow-hidden');
            resetConfirmCodeFormsAndClearErrors();
         }
      });
   });

   //Event handler for "Back" buttons
   function initializeBackButtons() {
      const backButtons = document.querySelectorAll('button[data-back]');

      backButtons.forEach(button => {
         button.addEventListener('click', () => {
            const modals = document.querySelectorAll('.wcl-modal-layout');
            const targetID = button.getAttribute('data-back');
            const form = document.getElementById(targetID);
            const modalLayout = form.closest('.wcl-modal-layout');

            modals.forEach(modal => {
               modal.classList.remove('active');
            });

            modalLayout.classList.add('active');
         });
      });
   }

   initializeBackButtons();



   /*
   * Login Button
   */
   const loginButton = document.getElementById('wcl-login-button');

   if (loginButton) {
      loginButton.addEventListener('click', () => {

         hiddenAllForms();

         const modalPasswordChanged = loginButton.closest('.wcl-modal-layout');
         const modalLoginForm = document.getElementById('wcl-login-popup');
         const modalLoginLayout = modalLoginForm.closest('.wcl-modal-layout');

         modalPasswordChanged.classList.remove('active');
         modalLoginLayout.classList.add('active');
         modalLoginForm.classList.add('active');
      });
   }
});
